module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio32-544cedc41602632a4da7f3612146f9c0.m4a";